import { DocumentsListsService } from '@/services/documents-lists.service';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';
import {EntityService} from "@/services/EntityService";

export class DocumentsListsItemsService extends EntityService {
  static entity(documentsListsId) {
    return `${DocumentsListsService.entity}/${documentsListsId}/items`;
  }

  static async getList(documentsListsId, parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({
        auth: true
      }).get(`${this.entity(documentsListsId)}`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getById(documentsListsId, id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity(documentsListsId)}/${id}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async create(documentsListsId, data = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity(documentsListsId)}`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async update(documentsListsId, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity(documentsListsId)}/${data.id}`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async remove(documentsListsId, id) {
    try {
      const response = await this.request({ auth: true }).delete(
        `${this.entity(documentsListsId)}/${id}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
